import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Card, Column } from '~/commonComponents';

export const HelpSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Card>
    <Column paddingVertical={40} paddingLeft={48}>
      <Typography as="span" bold size="heading_4" color={colors.primary[500]}>
        {title}
      </Typography>
      <Column gap={20} marginTop={20} marginLeft={20}>
        {children}
      </Column>
    </Column>
  </Card>
);
